import request from '../utils/request'
import baseUrl from './baseUrl'

export const fxList = (data) => request({
    url: baseUrl + '/order/selectForShop',
    method: 'POST',
    data
})